import { useCachedNavProfile } from '@utils/cache';
import { useIsClient } from '@utils/common';
import { Header } from '@outlet/components/Header';

import { useHeaderBasketQuery } from './gql/graphql.v4.generated';
import { useHeaderUserQuery, useOutletHeaderCatalogTreeQuery } from './gql/graphql.v3.generated';

interface Props {
  isMobileBottomBarEnabled?: boolean,
}

export const HeaderContainer: React.FC<Props> = ({
  isMobileBottomBarEnabled,
}) => {
  const isClient = useIsClient();

  const [cacheData, setCacheData] = useCachedNavProfile();

  const {
    data: catalogTreeData,
    loading: catalogTreeLoading,
  } = useOutletHeaderCatalogTreeQuery({
    context: {
      batch: true,
    },
  });

  const {
    data: userData,
    loading: userLoading,
  } = useHeaderUserQuery({
    context: {
      batch: true,
      ignoreAuthError: true,
    },
    skip: !isClient,
    onCompleted: ({ viewer }) => {
      if (viewer) {
        setCacheData({
          ...(cacheData || {}),
          viewer,
        });
      }
    },
    onError: () => setCacheData(undefined),
  });

  const { data: basketData } = useHeaderBasketQuery({
    context: {
      batch: true,
      ignoreAuthError: true,
      v4: true,
    },
    skip: !isClient,
    onCompleted: ({ basket }) => {
      if (basket) {
        setCacheData({
          ...(cacheData || {}),
          basket,
        });
      }
    },
  });

  return (
    <Header
      user={userData?.viewer || cacheData?.viewer}
      productsCount={basketData?.basket.productsCount || cacheData?.basket?.productsCount}
      catalogTreeJSON={catalogTreeData?.catalogTree?.outletCatalogTree}
      isUserLoading={userLoading}
      isCatalogTreeLoading={catalogTreeLoading}
      isMobileBottomBarEnabled={isMobileBottomBarEnabled}
    />
  );
};
